// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const PurchaseOrdersPage = lazy(() => import('./pages/PurchaseOrdersPage'));
const SuppliersPage = lazy(() => import('./pages/SuppliersPage'));
const PoTrackingPage = lazy(() => import('./pages/PoTrackingPage'));
const SupplierPerformancePage = lazy(() => import('./pages/SupplierPerformancePage'));

export const PurchasingRoutes: RouteObject = {
  path: 'purchasing',
  element: <ModuleGuard moduleId="operations.purchasing" />,
  children: [
    { path: 'purchase-orders', element: <PurchaseOrdersPage />, handle: { crumb: 'Purchase Orders' } },
    { path: 'suppliers', element: <SuppliersPage />, handle: { crumb: 'Suppliers' } },
    { path: 'po-tracking', element: <PoTrackingPage />, handle: { crumb: 'PO Tracking' } },
    { path: 'supplier-performance', element: <SupplierPerformancePage />, handle: { crumb: 'Supplier Performance' } },
  ],
};
